export default "__VITE_PUBLIC_ASSET__0bd8df71__"